import {
  FETCH_BLOCKED_USERS,
  FETCH_BLOCKED_USERS_SUCCESS,
  FETCH_BLOCKED_USERS_FAILED,
  BLOCK_USER,
  UNBLOCK_USER,
} from '../store/types';

const INITIAL_STATE = {
  map: {},
  loading: false,
  error: { flag: false, msg: null },
};

export const userblockreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BLOCKED_USERS:
      return { ...state, loading: true };
    case FETCH_BLOCKED_USERS_SUCCESS:
      return { ...state, map: action.payload || {}, loading: false };
    case FETCH_BLOCKED_USERS_FAILED:
      return {
        ...state,
        map: {},
        loading: false,
        error: { flag: true, msg: action.payload },
      };
    case BLOCK_USER:
      return {
        ...state,
        map: {
          ...state.map,
          [action.payload.blockedUid]: action.payload,
        },
      };
    case UNBLOCK_USER: {
      const next = { ...state.map };
      delete next[action.payload.blockedUid];
      return { ...state, map: next };
    }
    default:
      return state;
  }
};
